<template>


  <div class="content content-fixed content-auth">
    <div class="container" style="margin-top: -120px;">
      <div class="media align-items-stretch justify-content-center ht-100p">
        <div class="sign-wrapper mg-lg-r-50 mg-xl-r-60">
          <div class="pd-t-20 wd-100p">
            <h4 class="tx-color-01 mg-b-5">Create New Account</h4>
            <p class="tx-color-03 tx-16 mg-b-40">It's free to signup and only takes a minute.</p>

            <div class="form-group">
              <label>Firstname</label>
              <input v-model="firstName" type="text" class="form-control" placeholder="Enter your firstname">
            </div>

            <div class="form-group">
              <label>Lastname</label>
              <input v-model="lastName" type="text" class="form-control" placeholder="Enter your lastname">
            </div>

            <div class="form-group">
              <label>Email address</label>
              <input v-model="email" type="email" class="form-control" placeholder="Enter your email address">
            </div>

            <div class="form-group">
              <label>Phone Number</label>
              <input v-model="phone" type="email" class="form-control" placeholder="Enter your phone number">
            </div>

            <div class="form-group">
              <div class="d-flex justify-content-between mg-b-5">
                <label class="mg-b-0-f">Password</label>
              </div>
              <input v-model="password" type="password" class="form-control" placeholder="Enter your password">
            </div>
            <div class="form-group tx-12">
              By clicking <strong>Create an account</strong> below, you agree to our terms of service and privacy statement.
            </div><!-- form-group -->

            <button v-on:click="signUp" class="btn btn-brand-02 w-100">Create Account</button>

            <div class="divider-text">or</div>
            <div class="d-grid gap-2">
              <button class="btn btn-outline-facebook btn-block">Sign Up With Facebook</button>
              <button class="btn btn-outline-twitter btn-block">Sign Up With Twitter</button>
            </div>
            <div class="tx-13 mg-t-20 tx-center">Already have an account?
              <router-link to="/login"><strong>Sign in instead</strong></router-link>
            </div>
          </div>
        </div><!-- sign-wrapper -->
        <div class="media-body pd-y-30 pd-lg-x-50 pd-xl-x-60 align-items-center d-none d-lg-flex pos-relative">
          <div class="mx-lg-wd-500 mx-xl-wd-550">
            <img src="../../assets/img/login.webp" class="img-fluid" alt="">
          </div>

        </div><!-- media-body -->
      </div><!-- media -->
    </div><!-- container -->
  </div><!-- content -->

  <AuthFooter/>

</template>

<script>

import footerScriptMixin from "../../mixins/footer-script";
import authService from '@/mixins/auth-service'
import AuthFooter from "./AuthFooter.vue";

export default {
  name: "SignUp",
  components: {AuthFooter},
  mixins: [footerScriptMixin, authService],
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
    };
  },
  created() {
    //alert(this.domain)
  },
  methods: {
    async signUp() {
      try {
        let result = await this.$axios.post(`${this.authServer}/signup`, {
          email: this.email,
          username: this.email,
          password: this.password,
          phone: this.phone,
          firstName: this.firstName,
          lastName: this.lastName,
          organizationAppId: this.orgAppId,
        });

        localStorage.setItem("account-created", JSON.stringify(result));
        this.$router.push({name: "Login"});
      } catch (error) {
        if (error.response) {
          // Pass error response to UI
          console.log(error.response.data);
        }
      }
    },
  },
  mounted() {
    let user = localStorage.getItem("user-info");
    if (user) {
      this.$router.push({name: "Message"});
    }
  },
};
</script>
